/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Desktop_OverlineInputs */

const en_mk_desktop_overline = /** @type {(inputs: Mk_Desktop_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP DESKTOP · OPTIONAL`)
};

const id_mk_desktop_overline = /** @type {(inputs: Mk_Desktop_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BYSTEP DESKTOP · OPSIONAL`)
};

/**
* | output |
* | --- |
* | "BYSTEP DESKTOP · OPTIONAL" |
*
* @param {Mk_Desktop_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_desktop_overline = /** @type {((inputs?: Mk_Desktop_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Desktop_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_desktop_overline(inputs)
	return en_mk_desktop_overline(inputs)
});